<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Modifica Dati Progetto" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
								<b-icon icon="pencil" variant="outline-secondary"></b-icon>
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	data() {
		return {
			rows: 0,
			perPage: 50,
			currentPage: 1,
			pathResource: "/gestioneattivitamoduli",
			linkedit: "/gestioneattivita/moduli",
			moduliFilter: {},
			btnAggiungi: false,
			items: [],
			fields: [
				{
					label: "Nome",
					key: "nome",
					sortable: true,
				},
				{
					label: "Versione",
					key: "versione",
					sortable: true,
				},
				{
					label: "Descrizione",
					key: "descrizione",
					sortable: true,
				},
				{
					label: "Descrizione",
					key: "descrizione",
					sortable: true,
				},
				{
					label: "Stato",
					key: "statoAttuale",
					sortable: true,
					thStyle: "width: 10rem",
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	methods: {
		init() {
			let me = this;
			me.loadData();
		},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource, me.moduliFilter, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
		onEdit(item) {
			let me = this;
			me.$router.replace(me.linkedit + "/edit/" + item.id).catch((err) => {
				err;
			});
		},
		onClickAggiungi() {},
	},
};
</script>

<style></style>
